import { FeatureToggleClientService } from 'feature-toggle-client';
const CALL_RECORDING_TRANSCRIPTION = 'call-recording-transcription';
export class CallsFeatures {
    static async isCallRecordingTranscriptionEnabled() {
        if (!this.callRecordingTranscriptionEnabled) {
            this.callRecordingTranscriptionEnabled = await FeatureToggleClientService.getInstance().isFeatureEnabled(CALL_RECORDING_TRANSCRIPTION, false);
        }
        return this.callRecordingTranscriptionEnabled;
    }
}
CallsFeatures.callRecordingTranscriptionEnabled = undefined;
